module.exports = __webpack_public_path__ + "img/way_a.6677edcf.jpg";